import React, { useEffect, useState, useReducer } from "react";
import Modal from "@mui/material/Modal";
import "../css/VUP_dash.css";
import { FxmsData } from "../fxms/datas/FxData";
import { FxMoDash } from "../fxms/components/mo/FxMoDash";

/*산단대시보드_통신상태 팝업 */
export const DetailModal = React.memo((props) => {
  const { setModal, open, complexInloNo, plantInloNo } = props;
  let { engId, cnt } = props;
  const [selectedObj, setSelectedObj] = useReducer((prev, next) => {
    return { ...prev, ...next };
  }, {
    state: "",
    engId: "",
    tab: ""
  });
  const [topLineText, setTopLineText] = useState("");
  const [netDataList, setNetDataList] = useState([]);
  const [sensorDataList, setSensorDataList] = useState([]);
  const [boxDataList, setBoxDataList] = useState([]);

  // console.log("boxDataList >>>", boxDataList);
  // console.log("netDataList >>>", netDataList);
  // console.log("sensorDataList >>>", sensorDataList);

  //관리대상 모달
  const [mngModal, setMngModal] = useState(false);
  const [clickedPlantObj, setClickedPlantObj] = useState({});

  let engList = FxmsData.getDatas("energy");
  let engIn = engList.map((engList) => engList.engId);
  let complexInloName = "";
  let plantList = {};

  const engOptionList = [
    { value: "totalCnt", name: "전체" },
    { value: "onCnt", name: "정상" },
    { value: "offCnt", name: "이상" },
  ];

  // 관리대상 모달 핸들러
  const mngTgHandler = (event, obj) => {
    if (selectedObj.engId === "NET") {
      event.preventDefault();
      return;
    }
    console.log("obj >> ", obj); // devicePid | plcPid
    setMngModal(!mngModal)
    setClickedPlantObj(obj);
  };

  if (plantInloNo !== undefined) {
    complexInloName = FxmsData.getDatas("inlo", {
      inloClCd: "PLANT",
      inloNo: plantInloNo,
    })[0].companyInloName;
    plantList = FxmsData.getDatas("inlo", {
      inloClCd: "PLANT",
      inloNo: plantInloNo,
    });
  } else {
    complexInloName = FxmsData.getDatas("inlo", {
      inloClCd: "COMPLEX",
      complexInloNo: complexInloNo,
    })[0].inloName;
    plantList = FxmsData.getDatas("inlo", {
      inloClCd: "PLANT",
      complexInloNo: complexInloNo,
    });
  }
  // 해당 공장의 산단을 가져옴

  const handleClose = () => {
    setModal(false);
  };

  useEffect(() => {
    // console.log("팝업에 들어온 engId >> ", engId);
    // console.log("팝업에 들어온 cnt >> ", cnt);
    getData();
    setSelectedObj({ state: cnt, engId: engId })
  }, []);

  useEffect(() => {
    setModalData();
  }, [engId, netDataList, sensorDataList]);

  function setModalData() {
    setSelectedObj({ engId: engId })
    if (engId === "NET") {
      setTopLineText("사업장 통신 현황");
      setSelectedObj({ tab: "net" })
      if (cnt === "totalCnt") {
        // + totalCnt
        setBoxDataList(netDataList);
      } else if (cnt === "onCnt") {
        // moOnlineStVal == 1
        setBoxDataList(netDataList.filter((obj) => obj.moOnlineStVal > 0));
      } else if (cnt === "offCnt") {
        //moOnlineStVal == 0
        setBoxDataList(netDataList.filter((obj) => obj.moOnlineStVal === 0));
      }
    } else {
      setTopLineText("계측기 통신 현황");
      setSelectedObj({ tab: "sensor" })
      if (engId !== "engTotal") {
        if (cnt === "totalCnt") {
          setBoxDataList(sensorDataList.filter((obj) => obj.engId === engId));
        } else if (cnt === "onCnt") {
          setBoxDataList(
            sensorDataList
              .filter((obj) => obj.engId === engId)
              .filter((obj) => obj.moOnlineStVal > 0)
          );
        } else if (cnt === "offCnt") {
          setBoxDataList(
            sensorDataList
              .filter((obj) => obj.engId === engId)
              .filter((obj) => obj.moOnlineStVal === 0)
          );
        }
      } else {
        setBoxDataList(sensorDataList);
      }
    }
  }

  //탭 전환
  function toggleOnClass(event) {
    let clicked = event.currentTarget.id;
    const liElements = event.currentTarget.parentNode.children;
    for (let i = 0; i < liElements.length; i++) {
      liElements[i].classList.remove("on");
    }
    event.currentTarget.classList.add("on");
    clicked === "sensor" ? (engId = "engTotal") : (engId = "NET");
    cnt = "totalCnt";
    setSelectedObj({ state: "totalCnt", tab: clicked })
  }

  //현재 산단명
  //탭[net |sonsor] 에 따른 콤보박스 셋팅
  const getCombobox = (tabId) => {
    let tmpHtml = [];

    tmpHtml.push(
      <select value={complexInloNo} disabled>
        <option value={complexInloNo}>{complexInloName}</option>
      </select>
    );
    if (tabId !== "sensor") {
      tmpHtml.push(
        <select value={selectedObj.state} onChange={handleChangeNet}>
          {engOptionList.map((obj) => (
            <option value={obj.value}> {obj.name} </option>
          ))}
        </select>
      );
    } else {
      tmpHtml.push(
        <>
          <select value={selectedObj.engId} onChange={handleChangeSensor}>
            <option value={"engTotal"}> 전체 </option>
            {engList.map((obj) => (
              <option value={obj.engId}> {obj.engName} </option>
            ))}
          </select>
          <select value={selectedObj.state} onChange={handleChangeSensor}>
            {engOptionList.map((obj) => (
              <option value={obj.value}> {obj.name} </option>
            ))}
          </select>
        </>
      );
    }
    return tmpHtml;
  };

  // 통신상태 데이터박스 - 상태
  const handleChangeNet = (event) => {
    const value = event.target.value;
    const tempData = netDataList;

    if (value === "totalCnt") {
      setSelectedObj({ state: "totalCnt" });
      setBoxDataList(tempData);
    } else if (value === "onCnt") {
      // moOnlineStVal == 1
      setSelectedObj({ state: "onCnt" });
      setBoxDataList(tempData.filter((obj) => obj.moOnlineStVal > 0));
    } else if (value === "offCnt") {
      //moOnlineStVal == 0
      setSelectedObj({ state: "offCnt" });
      setBoxDataList(tempData.filter((obj) => obj.moOnlineStVal === 0));
    }
  };

  // 계측기상태 데이터박스 - 에너지명 | 상태
  const handleChangeSensor = (event) => {
    const value = event.target.value;
    const tempData = sensorDataList;

    //만약 선택한 밸류가 에너지 명에 포함되어 있다면
    if (engIn.includes(value)) {

      setSelectedObj({ state: "totalCnt", engId: value })
      setBoxDataList(tempData.filter((obj) => obj.engId === value));
    } else if (value === "totalCnt") {
      setSelectedObj({ state: "totalCnt" });

      if (selectedObj.engId !== "engTotal") {
        setBoxDataList(tempData.filter((obj) => obj.engId === selectedObj.engId));
      } else {
        setBoxDataList(tempData);
      }
    } else if (value === "onCnt") {
      // moOnlineStVal == 1
      setSelectedObj({ state: "onCnt" });

      if (selectedObj.engId !== "engTotal") {
        setBoxDataList(
          tempData
            .filter((obj) => obj.moOnlineStVal > 0)
            .filter((obj) => obj.engId === selectedObj.engId)
        );
      } else {
        setBoxDataList(tempData.filter((obj) => obj.moOnlineStVal > 0));
      }
    } else if (value === "offCnt") {
      //moOnlineStVal == 0
      setSelectedObj({ state: "offCnt" });

      if (selectedObj.engId !== "engTotal") {
        setBoxDataList(
          tempData
            .filter((obj) => obj.moOnlineStVal === 0)
            .filter((obj) => obj.engId === selectedObj.engId)
        );
      } else {
        setBoxDataList(tempData.filter((obj) => obj.moOnlineStVal === 0));
      }
    } else {
      // engTotal
      setSelectedObj({ state: "totalCnt", engId: value })
      setBoxDataList(tempData);
    }
  };

  /**
   * 계측기 상태 목록 조회(총괄, 산단, 공장 공용)
   *
   * @param {*} complexInloNo 산단위치번호
   * @param {*} companyInloNo 회사위치번호
   * @param {*} plantInloNo 공장위치번호
   *
   * comm_state_list: (15) [{…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}]
   * sensor_state_list: (28) [{…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}]
   */
  async function getData() {
    let dataList = {};
    if (plantInloNo !== undefined) {
      dataList = await FxmsData.GET("vup/dash/sensor/state/list", {
        plantInloNo: plantInloNo,
      });
    } else {
      dataList = await FxmsData.GET("vup/dash/sensor/state/list", {
        complexInloNo: complexInloNo,
      });
    }
    setNetDataList(dataList.data.comm_state_list);
    setSensorDataList(dataList.data.sensor_state_list);
  }

  //html tab 상단
  const getTabList = (engId) => {
    return (
      <>
        <div className="pop_topline">
          <div>
            {topLineText}
            {getCombobox(selectedObj.tab)}
          </div>
          <div className="tabGroup">
            <ul>
              <li
                id="net"
                className={engId === "NET" ? "on" : ""}
                onClick={(event) => {
                  toggleOnClass(event);
                  setModalData();
                }}
              >
                사업장
              </li>
              <li
                id="sensor"
                className={engId !== "NET" ? "on" : ""}
                onClick={(event) => {
                  toggleOnClass(event);
                  setModalData();
                }}
              >
                계측기
              </li>
            </ul>
          </div>
        </div>
      </>
    );
  };

  //html 데이터박스
  const getTabDataBox = () => {
    return (
      <>
        <div className={`factory_DataBox ${selectedObj.engId === "NET" ? "net" : ""}`}>
          <ul>
            {boxDataList.map((obj, index) => {
              const dividedStrings = obj.moName.split(" / ");
              const firstLine = dividedStrings[0];
              const secondLine = dividedStrings[1];
              return (
                <li
                  key={index}
                  className={obj.moOnlineStVal === 0 ? "error" : ""}
                  value={obj.companyInloNo}
                  onClick={(event) => mngTgHandler(event, obj)}
                >
                  {plantList.find((item) => item.companyInloNo === obj.companyInloNo).inloName}
                  {/* <br />{firstLine} */}
                  {secondLine && <br />}{secondLine}
                  <br /><span>({obj.moType})</span>
                </li>
              );
            })}
          </ul>
        </div>
      </>
    );
  };

  return (
    <div>
      {complexInloNo ? (
        <>
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <div
              className="popupBasic"
              style={{ width: "980px", minHeight: "500px", top: "25%" }}
            >
              <div className="closeBtn" onClick={handleClose}>
                <img src="../svgCloseBtn_on.svg" />
                <img src="../svgCloseBtn.svg" />
              </div>
              <h1>통신 문제 발생 현황</h1>
              {getTabList(engId)}
              {getTabDataBox()}
            </div>
          </Modal>
        </>
      ) : null}

      {/* 관리대상 모델 팝업 */}
      {mngModal && (
        <FxMoDash
          setMngTgModal={setMngModal}
          open={true}
          plantObj={clickedPlantObj}
        />
      )}
    </div>
  );
});
